module.exports = __webpack_public_path__ + "static/media/kaila.666351c1.png";